import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useProjects } from "@/contexts/ProjectContext";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import PageHeader from "@/components/dashboard/PageHeader";

export default function InternalLinksPage() {
  const { activeProjectId } = useProjects();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!activeProjectId) return;
    api.get(`/internal-links/${activeProjectId}`).then(({ data }) => setRows(data));
  }, [activeProjectId]);

  return (
    <DashboardLayout>
      <PageHeader
        overline="Internal Linking Engine"
        title="Recommended links across your site."
        description="From content to conversion pages, category pages to flagship offers, and comparison pages to checkout — automatically."
      />
      <div className="bg-white border border-border rounded-sm overflow-hidden">
        <table className="w-full text-sm" data-testid="internal-links-table">
          <thead className="bg-ivory-100 text-left text-[11px] uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="px-4 py-3">From</th>
              <th className="px-4 py-3">To</th>
              <th className="px-4 py-3">Reason</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-border">
                <td className="px-4 py-3 font-mono text-xs">{r.source_url}</td>
                <td className="px-4 py-3 font-mono text-xs text-gold-600">{r.target_url}</td>
                <td className="px-4 py-3 text-muted-foreground">{r.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
